document.addEventListener('DOMContentLoaded', function () {
  var citySelect = document.getElementById('delivery-city');
  var selectedCityDisplay = document.getElementById('selected-city-value');
  var selectedCityContainer = document.querySelector('.selected-city');
  var priceDisplay = document.getElementById('delivery-price-value');
  var customer_email = document.getElementById('c_email');
  var customer_name = document.getElementById('c_name');
  var priceContainer = document.querySelector('.delivery-price');
  //var priceHiddenInput = document.getElementById('delivery-price-hidden');
  var dateInput = document.getElementById("delivery-date");
  var timeslotSelect = document.getElementById("timeslot");
  var specificTimeslot = document.getElementById("specific-time-select");
  var card_message_to = document.getElementById("card_message_to");
  var card_message_from = document.getElementById("card_message_from");
  var phone = document.getElementById("phone");
  var phone_code = document.getElementById("phone_code");
  var countryCode = 'ID'; // Fallback to 'ID'
  var recipient_name = document.getElementById('recipient_name');
  var recipient_last_name = document.getElementById('recipient_last_name');
  var recipient_phone = document.getElementById('recipient_phone');
  var recipient_phone_code = document.getElementById('recipient_phone_code');
  var recipient_address = document.getElementById('recipient_address');
  var zip = document.getElementById('zip');
  var stickyAddToCartBtn = document.getElementById('product-sticky-add-to-cart');
  
  //var countryCode = Shopify?.country || 'ID'; // Fallback to 'ID'

  //cart occasion
  var occasionSelect = document.getElementById('occasion');
  var messageTemplateSelect = document.getElementById('message_template');
  var card_message = document.getElementById('card_message');
  
  // Helper to format currency
  function formatCurrency(value) {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(value);
  }

  // Disable add-to-cart buttons and hide elements
  function disableAddToCart() {
    var addToCartBtn = document.getElementById('product-add-to-cart');

    if (addToCartBtn) {
      addToCartBtn.textContent = 'Sold Out';
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
    }
    if (stickyAddToCartBtn) {
      stickyAddToCartBtn.textContent = 'Sold Out';
      stickyAddToCartBtn.disabled = true;
      stickyAddToCartBtn.classList.add('disabled');
    }
    $(".productView-payment").hide();
    $(".global-checkbox").hide();
    $(".quantity__container").hide();
  }

  // Fetch and populate timeslots for a given date
  function fetchTimeslots(selectedDate) {
    if (!selectedDate || !timeslotSelect) return;

    var queryParams = new URLSearchParams({
      domain_alias: "fa.co.id",
      country_code: countryCode,
      date: selectedDate,
      recipient_city: sessionStorage.getItem("selected_city") || "",
      shopify_product_ids: productIdsString || ""
    });

    var primaryApiUrl =
      "https://api.floweradvisor.com/api/timeslot?" + queryParams.toString();

    var fallbackApiUrl =
      "https://admin.floweradvisor.net/api/timeslot?" + queryParams.toString();

    timeslotSelect.innerHTML = `<option value="">Loading...</option>`;

    function requestTimeslots(url) {
      return fetch(url).then(function (response) {
        if (!response.ok) {
          throw new Error("HTTP error: " + response.status);
        }

        return response.json();
      }).then(function (data) {
        var hasValidSlots =
          data &&
          data.error === 0 &&
          Array.isArray(data.data) &&
          data.data.length > 0;

        if (!hasValidSlots) {
          throw new Error(data?.message || "No time slots found");
        }

        return data;
      });
    }

    requestTimeslots(primaryApiUrl)
      .catch(function (primaryError) {
        console.warn(
        "Primary timeslot API failed. Trying fallback:",
        primaryError
      );

      return requestTimeslots(fallbackApiUrl);
    })
    .then(function (data) {
      timeslotSelect.innerHTML =
        `<option value="">Select a time slot</option>`;

      if (specificTimeslot) {
        specificTimeslot.innerHTML = "";
      }

      data.data.forEach(function (slot) {
        var option = document.createElement("option");

        option.value = String(slot.idx);
        option.textContent = slot.text;
        option.setAttribute(
          "data-specifictime",
          slot.is_specific_timing
        );
        option.setAttribute("data-charge", slot.charge);
        option.setAttribute("data-start-time", slot.start_time);
        option.setAttribute("data-end-time", slot.end_time);
        option.setAttribute("data-cutoff-time", slot.cutoff_time);

        timeslotSelect.appendChild(option);
      });

      var storedTimeslot =
        sessionStorage.getItem("selected_timeslot");

      var isStoredTimeslotValid =
        storedTimeslot &&
        data.data.some(function (slot) {
          return String(slot.idx) === String(storedTimeslot);
        });

      if (!isStoredTimeslotValid) return;

      setTimeout(function () {
        timeslotSelect.value = storedTimeslot;

        // Find by value instead of using storedTimeslot as an array index.
        var selectedOption =
          timeslotSelect.options[timeslotSelect.selectedIndex];

        if (!selectedOption) return;

        var isSpecificTime =
          selectedOption.getAttribute("data-specifictime") === "1";

        var specificTimeDiv =
          document.getElementById("specific-time-div");

        if (!isSpecificTime) {
          if (specificTimeDiv) {
            specificTimeDiv.style.display = "none";
          }
          return;
        }

        if (specificTimeDiv) {
          specificTimeDiv.style.display = "block";
        }

        var startTime = parseInt(
          selectedOption.getAttribute("data-start-time"),
          10
        );

        var endTime = parseInt(
          selectedOption.getAttribute("data-end-time"),
          10
        );

        var specificTimeSelect =
          document.getElementById("specific-time-select");

        if (
          !specificTimeSelect ||
          Number.isNaN(startTime) ||
          Number.isNaN(endTime)
        ) {
          return;
        }

        specificTimeSelect.innerHTML = "";

        for (var hour = startTime; hour <= endTime; hour++) {
          var option = document.createElement("option");
          var nextHour = hour + 1;

          var startLabel =
            String(hour).padStart(2, "0") + ":00";

          var endLabel =
            String(nextHour).padStart(2, "0") + ":00";

          option.value = startLabel + " - " + endLabel;
          option.textContent = startLabel + " - " + endLabel;

          specificTimeSelect.appendChild(option);
        }
      }, 0);
    })
    .catch(function (error) {
      console.error(
        "Both timeslot endpoints failed:",
        error
      );

      timeslotSelect.innerHTML =
        `<option value="">No slots available</option>`;

      if (specificTimeslot) {
        specificTimeslot.innerHTML = "";
      }

      var specificTimeDiv =
        document.getElementById("specific-time-div");

      if (specificTimeDiv) {
        specificTimeDiv.style.display = "none";
      }
    });
  }

  
  if(stickyAddToCartBtn){
      stickyAddToCartBtn.addEventListener('click', function () {
        var addons = getAddonItems();
        var items = [];

        const form = document.querySelector('form[action="/cart/add"]');
        var variantId = form.querySelector('input[name="id"]')?.value || null;
        var qty = document.querySelector('input[name="quantity"]')?.value || 1;
        items.push({ id: variantId, quantity: qty });
        for(var i in addons){
            items.push({ id: addons[i].id, quantity: addons[i].quantity });
        }

        if(items.length > 0){
            fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({items})
            })
            .then(response => {
                return response.json();
            })
            .finally(() => {
                setTimeout(function() {window.location='/cart'; }, 3000);       
            });
        }
        else{
            //nothing todo
        }
     });
  }

  function getAddonItems(){
    const items = [];
    document.querySelectorAll('.addon-item').forEach((card) => {
      const qtyEl = card.querySelector('.qty-input');
      const qty = qtyEl ? parseInt(qtyEl.value, 10) || 0 : 0;
      const vid = Number(card.getAttribute('data-variant-id'));
      const available = (card.getAttribute('data-available') === 'true' || card.getAttribute('data-available') === 'True');
      if (qty > 0 && vid && available) items.push({ id: vid, quantity: qty });
    });

    // fallback if you still use checkboxes somewhere
    document.querySelectorAll('input[name="addons[]"]:checked').forEach((cb) => {
      const vid = Number(cb.value || cb.dataset.variantId);
      if (vid) items.push({ id: vid, quantity: 1 });
    });

    return items;
  }
  
if (citySelect) {

  var product_code =
    document.getElementById('product-sku-hidden').value;


  var CITY_API_BASE =
    "https://api.floweradvisor.com/api/city";


  var CITY_API_FALLBACK =
    "https://admin.floweradvisor.net/api/city";


  var cityQuery =
    "?country_code=" +
    encodeURIComponent(countryCode) +
    "&product_code=" +
    encodeURIComponent(product_code);


  var primaryCityUrl =
    CITY_API_BASE + cityQuery;


  var fallbackCityUrl =
    CITY_API_FALLBACK + cityQuery;


  // console.log(
  //   "CITY PRIMARY URL:",
  //   primaryCityUrl
  // );


  // console.log(
  //   "CITY FALLBACK URL:",
  //   fallbackCityUrl
  // );


  /*
   * ==========================================
   * REQUEST CITY API
   * ==========================================
   */
  function requestCityApi(url) {

    console.log(
      "REQUESTING CITY API:",
      url
    );


    return fetch(url, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        'Accept': 'application/json'
      }
    })


    .then(function (response) {

      // console.log(
      //   "CITY API HTTP RESPONSE:",
      //   response.status,
      //   url
      // );


      if (!response.ok) {

        throw new Error(
          "HTTP " + response.status
        );
      }


      return response.json();

    })


    .then(function (data) {

      console.log(
        "CITY API JSON RESPONSE:",
        url,
        data
      );


      /*
       * IMPORTANT:
       *
       * The API can return HTTP 200
       * but still contain:
       *
       * {
       *   error: 1,
       *   message: "..."
       * }
       *
       * Treat this as API failure so
       * fallback will be triggered.
       */
      if (
        data &&
        (
          data.error == 1 ||
          data.error === true
        )
      ) {

        throw new Error(
          data.message ||
          "City API returned an error"
        );
      }


      return data;

    });
  }


  /*
   * ==========================================
   * PROCESS CITY RESPONSE
   * ==========================================
   */
  function processCityResponse(data) {

    var result =
      data.data || [];


    console.log(
      "Available cities:",
      data
    );


    /*
     * No cities
     */
    if (result.length === 0) {

      disableAddToCart();

      citySelect.innerHTML =
        `<option value="">No cities available</option>`;

      return;
    }


    /*
     * Populate city dropdown
     */
    citySelect.innerHTML =
      `<option value="">Select a city</option>`;


    result.forEach(function (city) {

      var option =
        document.createElement('option');


      option.value =
        city.name
          .replace(/\s+/g, '_')
          .toLowerCase();


      if (city.charge == 0) {

        option.textContent =
          `${city.name} - Free`;

      }
      else {

        option.textContent =
          `${city.name} - ${formatCurrency(city.charge)}`;

      }


      option.dataset.price =
        city.charge;


      citySelect.appendChild(
        option
      );

    });


    /*
     * ==========================================
     * RESTORE STORED CITY
     * ==========================================
     */
    var storedCity =
      sessionStorage.getItem(
        'selected_city'
      );


    if (
      storedCity &&
      result.some(function (city) {

        return (
          city.name
            .replace(/\s+/g, '_')
            .toLowerCase() ===
          storedCity
        );

      })
    ) {

      citySelect.value =
        storedCity;


      var selectedOption =
        citySelect.selectedOptions[0];


      if (selectedOption) {

        Shopify.city =
          storedCity;


        if (selectedCityDisplay) {

          selectedCityDisplay.textContent =
            selectedOption.textContent
              .split(' - ')[0];

        }


        if (priceDisplay) {

          priceDisplay.textContent =
            formatCurrency(
              selectedOption.dataset.price
            );

        }

      }

    }

  }


  /*
   * ==========================================
   * PRIMARY CITY API
   * ==========================================
   */
  requestCityApi(primaryCityUrl)

    .then(function (data) {

      /*
       * PRIMARY SUCCESS
       */
      console.log(
        "CITY PRIMARY API SUCCESS"
      );


      processCityResponse(
        data
      );

    })


    .catch(function (primaryError) {

      /*
       * PRIMARY FAILED
       */
      console.error(
        "CITY PRIMARY API FAILED:",
        primaryError
      );


      console.warn(
        "===================================="
      );


      console.warn(
        "SWITCHING TO CITY FALLBACK API"
      );


      console.warn(
        fallbackCityUrl
      );


      console.warn(
        "===================================="
      );


      /*
       * ======================================
       * FALLBACK CITY API
       * ======================================
       */
      return requestCityApi(
        fallbackCityUrl
      );

    })


    .then(function (fallbackData) {

      /*
       * If primary succeeded,
       * fallbackData is undefined.
       *
       * If fallback succeeded,
       * process its data.
       */
      if (
        fallbackData !== undefined
      ) {

        console.log(
          "CITY FALLBACK API SUCCESS"
        );


        processCityResponse(
          fallbackData
        );

      }

    })


    .catch(function (fallbackError) {

      /*
       * BOTH APIs FAILED
       */
      console.error(
        "CITY FALLBACK API FAILED:",
        fallbackError
      );


      citySelect.innerHTML =
        `<option value="">Unable to load cities</option>`;

    });


  /*
   * ==========================================
   * CITY CHANGE EVENT
   * ==========================================
   */
  citySelect.addEventListener(
    'change',
    function () {

      var selectedValue =
        citySelect.value;


      var selectedOption =
        citySelect.selectedOptions[0];


      var selectedPrice =
        selectedOption
          ? selectedOption.dataset.price
          : '';


      /*
       * Update delivery price
       */
      if (selectedPrice !== '') {

        if (priceDisplay) {

          priceDisplay.textContent =
            formatCurrency(
              selectedPrice
            );

        }

      }
      else {

        if (priceDisplay) {

          priceDisplay.textContent =
            '';

        }

      }


      /*
       * Update city display
       */
      if (selectedCityDisplay) {

        selectedCityDisplay.textContent =
          selectedOption
            ? selectedOption.textContent
                .split(' - ')[0]
            : '';

      }


      /*
       * Shopify city variable
       */
      Shopify.city =
        selectedValue;


      /*
       * Save selected city
       */
      sessionStorage.setItem(
        'selected_city',
        selectedValue
      );


      /*
       * Refetch timeslots
       * when date + city are available
       */
      var selectedDate =
        dateInput
          ? dateInput.value
          : '';


      if (
        selectedDate &&
        selectedValue
      ) {

        fetchTimeslots(
          selectedDate
        );

      }

    }
  );

}



  function fetchMessageTemplate(occasion_code){
    fetch(`https://api.floweradvisor.com/api/card-message-template/`+occasion_code, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        var result = data.data;
        console.log('message template:', result);
        if (result.length === 0) {
          messageTemplateSelect.innerHTML = `<option value="">No Template for This Occasion</option>`;
        } else {
          messageTemplateSelect.innerHTML = `<option value="">Try Our Template message</option>`;
          result.forEach(occasion => {
            var option = document.createElement('option');
            option.value = occasion.message;
            option.textContent = occasion.title;
            messageTemplateSelect.appendChild(option);
          });
          
        }        
      })
      .catch(error => {
        console.error('Error fetching occasions:', error);
        messageTemplateSelect.innerHTML = `<option value="">Unable to load occasions</option>`;
      });

    messageTemplateSelect.addEventListener('change', function () {
      var selectedValue = messageTemplateSelect.value;
      console.log(selectedValue);
      card_message.value = selectedValue;
      sessionStorage.setItem('card_message', selectedValue);
    });  
  }
  
  if(card_message){
    var card_message_stored = sessionStorage.getItem('card_message');
    card_message.value = card_message_stored;

    card_message.addEventListener('blur', function () {
      var card_message_updated = card_message.value;
      sessionStorage.setItem('card_message', card_message_updated);
    });
  }

  if(card_message_to){
    var card_message_to_stored = sessionStorage.getItem('card_message_to');
    card_message_to.value = card_message_to_stored;

    card_message_to.addEventListener('blur', function () {
      var card_message_to_updated = card_message_to.value;
      sessionStorage.setItem('card_message_to', card_message_to_updated);
    });
  }

  if(card_message_from){
    var card_message_from_stored = sessionStorage.getItem('card_message_from');
    card_message_from.value = card_message_from_stored;

    card_message_from.addEventListener('blur', function () {
      var card_message_from_updated = card_message_from.value;
      sessionStorage.setItem('card_message_from', card_message_from_updated);
    });
  }
  
  if(occasionSelect){
    fetch(`https://api.floweradvisor.com/api/occasions`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        var result = data.data;
        console.log('Occasions:', result);
        if (result.length === 0) {
          occasionSelect.innerHTML = `<option value="">No occasion available</option>`;
        } else {
          occasionSelect.innerHTML = `<option value="">Select occasions</option>`;
          var skipOccasions = ['ANNI', 'CNVDAY','NEW','WHIT','FN','EAS','JB','PASS','SEC','TEACDAY'];
          

          for (var occasion of result) {
            if (skipOccasions.includes(occasion.code)) {
              continue; // properly skips to next iteration
            }
          
            var option = document.createElement('option');
            option.value = occasion.code;
            option.textContent = occasion.name;
            occasionSelect.appendChild(option);
          }
          

          var storedOccasion = sessionStorage.getItem('selected_occasion');
          if (storedOccasion && result.some(occasion => occasion.code === storedOccasion)) {
            occasionSelect.value = storedOccasion;
            fetchMessageTemplate(storedOccasion);
          }
          
        }        
      })
      .catch(error => {
        console.error('Error fetching occasions:', error);
        occasionSelect.innerHTML = `<option value="">Unable to load occasions</option>`;
      });

    occasionSelect.addEventListener('change', function () {
      var selectedValue = occasionSelect.value;
      
      sessionStorage.setItem('selected_occasion', selectedValue); // Persist city

      if (selectedValue) {
        fetchMessageTemplate(selectedValue);
      }
    });
    
  }
  
  if (dateInput) {
    var today = new Date().toISOString().split("T")[0];
    dateInput.setAttribute("min", today);
    var storedDate = sessionStorage.getItem('selected_date');
    if (storedDate && storedDate >= today && dateInput) {
      dateInput.value = storedDate;
      if (dateInput.value) {
        fetchTimeslots(storedDate);
      }
    }
    
    // Update date, fetch timeslots, and persist on change
    dateInput.addEventListener("change", function () {
      var selectedDate = dateInput.value;
      if (selectedDate) {
        sessionStorage.setItem('selected_date', selectedDate); // Persist date
        fetchTimeslots(selectedDate);
      } else {
        sessionStorage.removeItem('selected_date');
        if (timeslotSelect) {
          timeslotSelect.innerHTML = `<option value="">Select a time slot</option>`;
        }
      }
    });
  }

  if (timeslotSelect) {
    // Update timeslot and persist on change
    timeslotSelect.addEventListener('change', function () {
      var selectedTimeslot = timeslotSelect.value;
      if (selectedTimeslot) {
        const selectedOption = this.options[this.selectedIndex];
        const cutoffTime = selectedOption.dataset.cutoffTime;
        document.getElementById('cutoffTime').value = cutoffTime || '';
        sessionStorage.setItem('cutoffTime', cutoffTime);
        sessionStorage.setItem('selected_timeslot', selectedTimeslot); // Persist timeslot
      } else {
        sessionStorage.removeItem('selected_timeslot');
      }
    });
  }

  if(customer_email){
    var customer_email_stored = sessionStorage.getItem('customer_email');
    customer_email.value = customer_email_stored;

    customer_email.addEventListener('blur', function (e) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (e.target.value !== '' && !emailRegex.test(e.target.value)) {
        customer_email.value = '';
      } else {
        var customer_email_stored = customer_email.value;
        sessionStorage.setItem('customer_email', customer_email_stored);
      }      
    });  
  }
  
  if(customer_name){
    var customer_name_stored = sessionStorage.getItem('customer_name');
    customer_name.value = customer_name_stored;

    customer_name.addEventListener('blur', function (e) {
      var customer_name_stored = customer_name.value;
      sessionStorage.setItem('customer_name', customer_name_stored);      
    });  
  }

  if(phone){
    var phone_stored = sessionStorage.getItem('phone');
    if(phone_stored != null){
      phone.value = phone_stored;  
    }
    
    
    phone.addEventListener('blur', function () {
      var phone_updated = formatPhone(phone.value);
      phone.value = formatPhone(phone.value);
      sessionStorage.setItem('phone', phone_updated);
    });
  }

  if(phone_code){
    var phone_code_stored = sessionStorage.getItem('phone_code');
    if(phone_code_stored != null){
      phone_code.value = phone_code_stored;
    }
    else{
      sessionStorage.setItem('phone_code', phone_code.value);
    }
      
    

    phone_code.addEventListener('blur', function () {
      var phone_code_updated = phone_code.value;
      sessionStorage.setItem('phone_code', phone_code_updated);
    });
  }

  if(recipient_name){
    var recipient_name_stored = sessionStorage.getItem('recipient_name');
    recipient_name.value = recipient_name_stored;  
    

    recipient_name.addEventListener('blur', function () {
      var recipient_name_updated = recipient_name.value;
      sessionStorage.setItem('recipient_name', recipient_name_updated);
    });
  }

  if(recipient_last_name){
    var recipient_last_name_stored = sessionStorage.getItem('recipient_last_name');
    recipient_last_name.value = recipient_last_name_stored;  
    

    recipient_last_name.addEventListener('blur', function () {
      var recipient_last_name_updated = recipient_last_name.value;
      sessionStorage.setItem('recipient_last_name', recipient_last_name_updated);
    });
  }

  if(recipient_phone_code){
    var recipient_phone_code_stored = sessionStorage.getItem('recipient_phone_code');      
    if(recipient_phone_code_stored != null){
      recipient_phone_code.value = recipient_phone_code_stored;
    }
    else{
      sessionStorage.setItem('recipient_phone_code', recipient_phone_code.value);
    }

    recipient_phone_code.addEventListener('blur', function () {
      var recipient_phone_code_updated = recipient_phone_code.value;
      sessionStorage.setItem('recipient_phone_code', recipient_phone_code_updated);
    });
  }

  if(recipient_phone){
    var recipient_phone_stored = sessionStorage.getItem('recipient_phone');
    recipient_phone.value = recipient_phone_stored;  
    

    recipient_phone.addEventListener('blur', function () {
      var recipient_phone_updated = formatPhone(recipient_phone.value);
      recipient_phone.value = formatPhone(recipient_phone.value);
      sessionStorage.setItem('recipient_phone', recipient_phone_updated);
    });
  }

  if(recipient_address){
    var recipient_address_stored = sessionStorage.getItem('recipient_address');
    recipient_address.value = recipient_address_stored;  
    

    recipient_address.addEventListener('change', function () {
      var recipient_address_updated = recipient_address.value;
      sessionStorage.setItem('recipient_address', recipient_address_updated);
    });
  }
  
  if(zip){
    var zip_stored = sessionStorage.getItem('zip');
    zip.value = zip_stored;  
    

    zip.addEventListener('blur', function () {
      var zip_updated = zip.value;
      sessionStorage.setItem('zip', zip_updated);
    });
  }
});


function setShopifyCountry(countryCode) {
  fetch('/localization', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'xmlhttprequest',
    },
    body: JSON.stringify({
      country: countryCode // e.g., 'ID', 'SG', 'US'
    }),
  }).then(() => {
    location.reload(); // reload the page with new market context
  });
}





function openCityPopup() {
  document.getElementById('cityPopup').style.display = 'block';
  var dropdown = document.getElementById('cityDropdown');
  if (dropdown.options.length <= 1) {
    fetch('https://api.floweradvisor.com/api/city?country_code=ID')
      .then(response => response.json())
      .then(data => {
        dropdown.innerHTML = '';
        var result = data.data;
        result.forEach(city => {
          var option = document.createElement('option');
          option.value = city.alias;
          option.textContent = city.name;
          dropdown.appendChild(option);
        });

        // Set stored city if valid
          var storedCity = sessionStorage.getItem('selected_city');
          if (storedCity && result.some(city => city.name.replace(/\s+/g, '_').toLowerCase() === storedCity)) {
            dropdown.value = storedCity;
            var selectedOption = dropdown.selectedOptions[0];
          }


        
      });
  }
}

function formatWithEllipsis(str) {
  if (!str || typeof str !== 'string') return '';

  var words = str
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())
    .toLowerCase()
    .split(' ');

  if (words.length === 1) {
    return words[0].charAt(0).toUpperCase() + words[0].slice(1);
  } else {
    return words[0].charAt(0).toUpperCase() + words[0].slice(1) + '...';
  }
}

function updateCitySelection(city) {
  sessionStorage.setItem('selected_city', city);
  var elements = document.getElementsByClassName('selectedCityLabel');
  for (let element of elements) {
    element.textContent = formatWithEllipsis(city);
  }
  closeCityPopup();
}

function toCamelCaseFromUnderscore(str) {
  return str
    .replace(/_/g, ' ')                      // Replace underscores with spaces
    .toLowerCase()                           // Convert to lowercase
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize first letter of each word
}


function closeCityPopup() {
  document.getElementById('cityPopup').style.display = 'none';
}

document.addEventListener('DOMContentLoaded', function () {
  var saved = formatWithEllipsis(sessionStorage.getItem('selected_city'));
  if (saved) {
    var elements = document.getElementsByClassName('selectedCityLabel');
    for (let element of elements) {
      element.textContent = formatWithEllipsis(saved);
    }
  }
});

function collapsedProductAddOnsWhenReady() {
  var intervalId = setInterval(() => {
    var productAddOnsElements = document.querySelector('.spice-spa-addon-product-wrapper .spice-addon-group-dropdownBox');

    if (productAddOnsElements) {
      productAddOnsElements.classList.add('spice-addon-group-active');
      clearInterval(intervalId); // Stop polling setelah elemen ditemukan
    }
  }, 200); 
}

function isNumberKey(evt) {
    var charCode = (evt.which) ? evt.which : event.keyCode
    if (charCode > 31 && (charCode < 48 || charCode > 57))
        return false;

    return true;
}

function formatPhone(phone) {
  return phone.replace(/^0/, '');
}


collapsedProductAddOnsWhenReady();

document.addEventListener("DOMContentLoaded", () => {
  const qiscusBtn = document.querySelector(".qiscus");
  if (qiscusBtn) {
    qiscusBtn.dataset.initialContent = qiscusBtn.innerHTML;
  }

  const speedDial = document.querySelector(".speed-dial");
  if (!speedDial) return;

  const mainBtn = speedDial.querySelector(".main-btn");
  mainBtn.addEventListener("click", () => {
    speedDial.classList.toggle("open");
  });

  $(document).on("click", ".qiscus", function () {
    $(".qiscus").off("click");
    showLoading(".qiscus", "show");

    const style = document.createElement("style");
    style.innerHTML = "#qismo-widget { display: none !important; }";
    document.head.appendChild(style);

    function activateQiscus() {
      const triggerInterval = setInterval(() => {
        const triggerBtn = document.querySelector(".qcw-trigger-btn");
        if (triggerBtn) {
          triggerBtn.click();
          clearInterval(triggerInterval);

          const channelInterval = setInterval(() => {
            const channelItem = document.querySelector(".qismo-channel__item");
            if (channelItem) {
              channelItem.click();
              clearInterval(channelInterval);
              showLoading(".qiscus", "hide");
            }
          }, 300);
           showLoading(".qiscus", "hide");
        }
      }, 300);
    }

    if (window.qiscusLoaded) {
      activateQiscus();
      return;
    }

    window.qiscusLoaded = true;

    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://omnichannel.qiscus.com/js/qismo-v4.js";
    script.async = true;
    script.onload = () => {
      new Qismo("qduvq-ntsnc4juuknjvbl", {
        options: {
          channel_id: 130328,
          qismoIframeUrl: "https://omnichannel.qiscus.com",
          baseUrl: "https://omnichannel.qiscus.com",
          extra_fields: [],
        },
      });
      activateQiscus();
    };

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
  });
});

function showLoading(target, mode = "show") {
  const el = typeof target === "string" ? document.querySelector(target) : target;
  if (!el) return;

  if (mode === "show") {
    el.innerHTML =
      `<svg class="spin" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 50 50">
        <circle cx="25" cy="25" r="20" fill="none" stroke="white" stroke-width="5" stroke-linecap="round" stroke-dasharray="90" stroke-dashoffset="0"></circle>
      </svg>`;
  } else if (mode === "hide") {
    // Ganti dengan SVG spesifik
    el.innerHTML = `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.7994 18.3704L23.8013 18.373C24.1307 18.8032 24.2888 20.2316 22.0258 19.9779C21.3596 19.9033 20.4282 19.7715 19.3088 19.3471C18.5551 19.0613 17.8986 18.7026 17.3584 18.3522C16.4699 18.7098 15.5118 18.9296 14.5113 18.9857C13.1436 20.8155 10.9602 22 8.50001 22C7.69152 22 6.91135 21.8717 6.17973 21.6339C5.74016 21.8891 5.24034 22.1376 4.68789 22.3471C3.56851 22.7715 2.63949 22.9297 1.97092 22.9779C1.47028 23.014 1.11823 22.9883 0.944098 22.9681C0.562441 22.9239 0.219524 22.7064 0.072134 22.3397C-0.0571899 22.0179 -0.0104055 21.6519 0.195537 21.3728C0.448192 21.0283 0.680439 20.6673 0.899972 20.3011C1.32809 19.5868 1.74792 18.8167 1.85418 17.9789C1.30848 16.9383 1.00001 15.7539 1.00001 14.5C1.00001 11.5058 2.75456 8.92147 5.29159 7.71896C6.30144 3.85296 9.81755 1 14 1C18.9706 1 23 5.02944 23 10C23 11.3736 22.6916 12.6778 22.1395 13.8448C21.9492 15.5687 22.8157 17.0204 23.7994 18.3704ZM7.00001 10C7.00001 6.13401 10.134 3 14 3C17.866 3 21 6.13401 21 10C21 11.1198 20.7378 12.1756 20.2723 13.1118C20.2242 13.2085 20.1921 13.3124 20.1772 13.4194C19.9584 14.9943 20.3278 16.43 21.0822 17.8083C19.9902 17.5451 18.9611 17.0631 18.0522 16.4035C17.7546 16.1875 17.3625 16.1523 17.0312 16.3117C16.1152 16.7525 15.0879 17 14 17C10.134 17 7.00001 13.866 7.00001 10ZM5.00353 10.2543C5.11889 14.4129 8.05529 17.8664 11.9674 18.7695C11.0213 19.5389 9.8145 20 8.50001 20C7.7707 20 7.07689 19.8586 6.44271 19.6026C6.14147 19.481 5.79993 19.5133 5.52684 19.6892C5.08797 19.972 4.56616 20.2543 3.9788 20.477C3.58892 20.6248 3.23263 20.7316 2.91446 20.8083C3.24678 20.2012 3.58332 19.4779 3.73844 18.7971C3.81503 18.461 3.8572 18.1339 3.87625 17.8266C3.88848 17.6293 3.84192 17.4327 3.74245 17.2618C3.27058 16.451 3.00001 15.5086 3.00001 14.5C3.00001 12.7904 3.78 11.263 5.00353 10.2543Z" fill="white"></path>
</svg>
    `;
  } else {
    el.innerHTML = mode;
  }
}



function sendCSWA(wa_number) {
    var url = "https://wa.me/"+ wa_number + "?text=Hi+FlowerAdvisor+%2C+I+Need+Assistance+for+My+Inquiries";
    window.open(url);
}

